import React, { useState } from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import toast from 'react-hot-toast';
import api from '../../utils/api';

const TIPOS = [
  { value:'peticion',   label:'📋 Petición',   desc:'Solicitud de información o servicio' },
  { value:'queja',      label:'😟 Queja',       desc:'Inconformidad con un producto o servicio' },
  { value:'reclamo',    label:'⚠️ Reclamo',     desc:'Exigencia por un derecho' },
  { value:'sugerencia', label:'💡 Sugerencia',  desc:'Idea para mejorar nuestros productos o servicios' },
];

export default function Pqrs() {
  const [form, setForm] = useState({ tipo:'peticion', nombre:'', email:'', telefono:'', mensaje:'' });
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const enviar = async (e) => {
    e.preventDefault();
    if (!form.nombre || !form.email || !form.mensaje) return toast.error('Completa los campos requeridos');
    setEnviando(true);
    try {
      await api.post('/pqrs', form);
      setEnviado(true);
      toast.success('Tu PQR fue enviado exitosamente 🌿');
    } catch { toast.error('Error al enviar. Escríbenos por WhatsApp'); }
    finally { setEnviando(false); }
  };

  if (enviado) return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'PQRs' }]} />
      <div style={{ maxWidth:560, margin:'80px auto', padding:'0 24px', textAlign:'center' }}>
        <div style={{ fontSize:72, marginBottom:24 }}>✅</div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:32, color:'var(--forest)', marginBottom:12 }}>
          PQR enviado con éxito
        </h2>
        <p style={{ color:'var(--ink-light)', fontSize:15, lineHeight:1.8, marginBottom:32 }}>
          Hemos recibido tu solicitud. De acuerdo con la Ley 1581 de 2012 y nuestro compromiso como empresa ecológica, te responderemos en un plazo máximo de <strong>15 días hábiles</strong>.
        </p>
        <a href="/" className="btn btn-primary" style={{ padding:'12px 32px' }}>Volver a la tienda</a>
      </div>
    </div>
  );

  return (
    <div>
      <Breadcrumb items={[{ label:'Wawita', href:'/' }, { label:'PQRs' }]} />
      <div style={{ maxWidth:780, margin:'0 auto', padding:'60px 24px' }}>
        <h1 style={{ fontFamily:'var(--font-display)', fontSize:42, color:'var(--forest)', marginBottom:8 }}>
          Peticiones, Quejas, Reclamos y Sugerencias
        </h1>
        <div style={{ width:60, height:4, background:'#9FBE6A', borderRadius:2, marginBottom:16 }} />
        <p style={{ color:'var(--ink-light)', fontSize:15, lineHeight:1.8, marginBottom:40 }}>
          En Wawita valoramos tu opinión. Conforme a la normativa colombiana (Ley 1480 de 2011 — Estatuto del Consumidor), tienes derecho a presentar PQRs y recibirás respuesta en un plazo máximo de <strong>15 días hábiles</strong>.
        </p>

        {/* Selector de tipo */}
        <div style={{ display:'grid', gridTemplateColumns:'repeat(2,1fr)', gap:12, marginBottom:32 }}>
          {TIPOS.map(t => (
            <div key={t.value}
              onClick={() => setForm(f => ({ ...f, tipo: t.value }))}
              style={{
                padding:'16px 20px', borderRadius:14, cursor:'pointer', transition:'all 0.2s',
                border: form.tipo === t.value ? '2px solid #9FBE6A' : '2px solid rgba(28,58,30,0.1)',
                background: form.tipo === t.value ? 'rgba(159,190,106,0.12)' : '#fff',
              }}>
              <div style={{ fontWeight:700, fontSize:15, color:'var(--forest)', marginBottom:4 }}>{t.label}</div>
              <div style={{ fontSize:12, color:'var(--ink-faint)' }}>{t.desc}</div>
            </div>
          ))}
        </div>

        <div className="card">
          <div className="card-body">
            <form onSubmit={enviar}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16 }}>
                <div className="form-group">
                  <label className="form-label">Nombre completo *</label>
                  <input className="form-input" placeholder="María García"
                    value={form.nombre} onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Correo electrónico *</label>
                  <input className="form-input" type="email" placeholder="maria@email.com"
                    value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} />
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Teléfono / WhatsApp</label>
                  <input className="form-input" placeholder="+57 300..."
                    value={form.telefono} onChange={e => setForm(f => ({ ...f, telefono: e.target.value }))} />
                </div>
                <div className="form-group" style={{ gridColumn:'1/-1' }}>
                  <label className="form-label">Descripción detallada *</label>
                  <textarea className="form-input" rows={6} style={{ resize:'vertical' }}
                    placeholder="Describe tu petición, queja, reclamo o sugerencia con el mayor detalle posible..."
                    value={form.mensaje} onChange={e => setForm(f => ({ ...f, mensaje: e.target.value }))} />
                </div>
              </div>
              <div style={{ background:'rgba(159,190,106,0.1)', borderRadius:10, padding:'12px 16px', marginBottom:20, fontSize:13, color:'var(--ink-mid)' }}>
                🌿 Tus datos serán tratados conforme a nuestra <a href="/privacidad" style={{ color:'var(--forest)', fontWeight:700 }}>Política de Privacidad</a> y la Ley 1581 de 2012.
              </div>
              <button type="submit" className="btn btn-primary"
                style={{ width:'100%', padding:14, fontSize:15 }} disabled={enviando}>
                {enviando ? 'Enviando...' : 'Enviar PQR'}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
